module.exports = __webpack_public_path__ + "img/arepa_pollo.240a83bb.jpg";